import React, { useEffect, useState } from "react";
import { Container, Box, Typography, TextField } from "@mui/material";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";


const FifthSection = () => {
  return (
    <Grid
      container
      sx={{
        backgroundColor: "#140E3A",
        justifyContent: "center",
        padding: "5% 5% 5% 5%",
        display: "flex",
        flexDirection: "column",
      }}
      spacing={2}
    >
      <Grid item>
        <Typography
          sx={{
            fontWeight: 600,
            fontFamily: "Poppins",
            fontSize: "40px",
            lineHeight: "60px",
            textAlign: "center",
          }}
          variant="h6"
        >
          Don&apos;t miss out, Stay updated
        </Typography>
      </Grid>
      <Grid item sx={{ textAlign: "center" }}>
        <input
          type="text"
          style={{
            borderRadius: "28px",
            border:'none',
            backgroundColor: "#292A47",
            width: "360px",
            height: "56px",
            padding:'20px',
            fontSize:"25px",
          }}
          placeholder= "Enter your email address"
        ></input>
        <Button
          variant="contained"
          sx={{
            borderRadius: "28px",
            width: "171px",
            height: "50px",
            ml: "30px",
          }}
        >
          Subscribe
        </Button>
      </Grid>
      <Grid mt={5} textAlign="center">
        <Typography
          sx={{
            fontWeight: 500,
            fontFamily: "Poppins",
            fontSize: "18px",
            lineHeight: "24px",
            textAlign: "center",
          }}
        >
          Don&apos;t hesitate to subscribe to latest news about markets as well as
          crucial
          <br /> financial knowledge to become successful investors globally
        </Typography>
      </Grid>
      <Grid mt={5} textAlign="center">
        <img style={{ marginRight: "25px" }} src="./img/facebook.svg"></img>
        <img style={{ marginRight: "25px" }} src="./img/twiter.svg"></img>
        <img style={{ marginRight: "25px" }} src="./img/instagram.svg"></img>
        <img style={{ marginRight: "25px" }} src="./img/linkedIn.svg"></img>
        <img style={{ marginRight: "25px" }} src="./img/youtube.svg"></img>
        <div
          style={{
            height: 2,
            width: "100%",
            backgroundColor: "#23234b",
            marginTop: "7%",
          }}
        ></div>
        <Typography sx={{ mt: "40px", mb: "40px" }}>
          Copyright © 2021. All rights reserved by Your Company.
        </Typography>
      </Grid>
    </Grid>
  );
};
export default FifthSection;
